import React from 'react'
import Filterbox from '../components/filterbox'
import Mens from '../components/Mens'
import '../cssfiles/panel.css'
function panel() {




    return (
        <div>
        <div className='home'>
            <div className='home_panellist-wrap'>
                <div className='home_panel_wrap'>
                    <Filterbox />
                </div>

                <div className='home_list_wrap'>
                    <Mens />
                </div>
            </div>
        </div></div>
    )
}

export default panel